import JsonLd from '../JsonLd';

interface CourseSchemaProps {
  price?: number;
  currency?: string;
}

const CourseSchema: React.FC<CourseSchemaProps> = ({ 
  price = 997, 
  currency = 'USD' 
}) => {
  const courseData = {
    "@context": "https://schema.org",
    "@type": "Course",
    "name": "AI Governance Blueprint for Board Directors",
    "description": "A comprehensive 12-module course designed to equip board directors with the knowledge and frameworks needed to provide effective oversight of AI initiatives. Learn AI fundamentals, risk management, regulatory compliance, and governance best practices.",
    "url": "https://boardsight.ai/blueprint",
    "provider": {
      "@type": "Organization",
      "name": "BoardSight AI",
      "url": "https://boardsight.ai"
    },
    "educationalLevel": "Executive",
    "audience": {
      "@type": "Audience",
      "audienceType": "Board Directors, C-Suite Executives, Corporate Governance Professionals"
    },
    "inLanguage": "en",
    "isAccessibleForFree": false,
    "hasCourseInstance": {
      "@type": "CourseInstance",
      "courseMode": "online",
      "courseWorkload": "PT20H"
    },
    "offers": {
      "@type": "Offer",
      "price": price,
      "priceCurrency": currency,
      "availability": "https://schema.org/InStock",
      "validFrom": "2024-01-01"
    },
    "syllabusSections": [
      {
        "@type": "Syllabus",
        "name": "Part 1: Foundations of AI Governance",
        "description": "Core AI concepts, strategic opportunities, global landscape, and risk taxonomy"
      },
      {
        "@type": "Syllabus", 
        "name": "Part 2: Risk Management & Governance",
        "description": "Ethical frameworks, regulatory compliance, data governance, and cybersecurity"
      },
      {
        "@type": "Syllabus",
        "name": "Part 3: Implementation & Board Responsibilities",
        "description": "Fiduciary duties, governance structures, board readiness, and incident response"
      }
    ],
    "teaches": [
      "AI terminology and concepts for board oversight",
      "AI risk identification and assessment",
      "EU AI Act and global regulatory compliance",
      "Data governance frameworks for AI",
      "Board fiduciary duties for AI oversight",
      "AI governance committee structures",
      "AI incident response planning",
      "Ethical AI frameworks and explainability"
    ],
    "numberOfCredits": "12 CPE Credits",
    "occupationalCredentialAwarded": {
      "@type": "EducationalOccupationalCredential",
      "credentialCategory": "certificate",
      "name": "AI Governance Certificate for Board Directors"
    }
  };

  return <JsonLd data={courseData} />;
};

export default CourseSchema;
